import { isUndefined } from 'lodash';
import { Reducer, useReducer } from 'react';
import { store } from '~/utils/store';
/*
  A utility hook for tracking the value of a boolean.

  const [isOn, toggle] = useToggle(true);

  <div>{isOn ? 'On' : 'Off'}</div>
  <button onClick={() => toggle()}>Toggle</button>
  <button onClick={() => toggle(true)}>Turn On</button>
  <button onClick={() => toggle(false)}>Turn Off</button>
*/

const toggleReducer = (state: boolean, nextValue?: any) =>
  typeof nextValue === 'boolean' ? nextValue : !state;

export const useToggle = (initialValue: boolean): [boolean, (nextValue?: any) => void] => {
  return useReducer<Reducer<boolean, any>>(toggleReducer, initialValue);
};

/*
  A utility hook for tracking the value of a boolean that also corresponds to a store value.

  const [isOn, toggle] = useToggle('SHOW_DIAGRAMS');

  <div>{isOn ? 'On' : 'Off'}</div>
  <button onClick={() => toggle(true)}>Turn On</button>
  <button onClick={() => toggle(false)}>Turn Off</button>
*/

// TODO: better way to do this - want all StoreKeyValuePairs w/ boolean value
type Option = 'DEV_TOOLS' | 'SHOW_DIAGRAMS' | 'NO_DASHBOARD';

export const useStoreToggle = (storeKey: Option): [boolean, (nextValue?: boolean) => void] => {
  const [value, setValue] = useReducer<Reducer<boolean, any>>(
    toggleReducer,
    isUndefined(store.get(storeKey)) ? false : (store.get(storeKey) as boolean),
  );
  const setter = (newValue?: boolean) => {
    setValue(newValue);
    if (newValue) {
      store.set(storeKey, true);
    } else {
      store.remove(storeKey);
    }
  };
  return [value, setter];
};
